// hooks/useCotaUsuario.ts
import { useState, useEffect } from "react";
import { buscarPaisesService } from "../services/buscarPaisesService";

import { Pais } from "../interfaces/Pais";

export const useBuscarPaises = (fetch: boolean) => {
  const [isLoading, setIsLoading] = useState(true);
  const [paises, setPaises] = useState<Pais[]>([]);

  useEffect(() => {
    const fetchPaises = async () => {
      if (fetch) {
        setIsLoading(true);
        try {
          const data = await buscarPaisesService();
          if (data) {
            setPaises(data);
          } else {
            console.error("Dados não encontrados para o usuário");
          }
        } catch (error) {
          console.error("Erro ao buscar emprendimentos:", error);
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    fetchPaises();
  }, [fetch]); // Dependência de usuarioId e fetch para garantir que a chamada seja feita quando necessário

  return { isLoading, paises };
};
